import {routes, request} from "./"

export function createDiscount(commit, data) {
    return request(commit, routes.discounts.create, data, 'post')
}

export function updateDiscount(commit, data) {
    return request(commit, routes.discounts.update, data, 'post')
}

export function deleteDiscount(commit, data) {
    return request(commit, routes.discounts.delete, data, 'post')
}



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/api/discounts.js
// module id = 604
// module chunks = 0